module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjU5MDM4IDAuNTg1MTY3QzYuNzg5NDMgMC4zMDA4MDkgNy4yMTA1NiAwLjMwMDgwOSA3LjQwOTYyIDAuNTg1MTY3TDEzLjQ0OTMgOS4yMTMyN0MxMy42ODEzIDkuNTQ0NjYgMTMuNDQ0MiAxMCAxMy4wMzk3IDEwTDAuOTYwMzI2IDEwQzAuNTU1ODE1IDEwIDAuMzE4NzM4IDkuNTQ0NjYgMC41NTA3MSA5LjIxMzI3TDYuNTkwMzggMC41ODUxNjdaIiBmaWxsPSIjN0M4Q0FCIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dropdown_UpArrow.svg
// module id = nZiJ
// module chunks = 1